export const KIOSK_ACCESSOR_STATUSES = {
    billAccepted: 9,
    billAcceptedPiramid: 3,
};
